import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	linkExactActiveClass: "active",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/try-now",
			name: "try-now",
			component: () => import(/* webpackChunkName: "try-now" */ "./views/TryNow.vue")
		},
		{
			path: "/contact",
			name: "contact",
			component: () => import(/* webpackChunkName: "contact" */ "./views/Contact.vue")
		}
	]
});
